export default __webpack_public_path__ + "static/media/volkswagen.2dbaf9cf.webp";